import { mapMutations, mapState, mapActions } from 'vuex'
import moment from 'moment'
import maCounter from '@/components/counter'
import { apiPostAdditionalInfo } from '@/services/API/additionalInfo'
import {
  WARRANTY_MODULE_ADDITIONAL_INFO,
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_NAME,
  WARRANTY_UPDATE_PROPS,
  WARRANTY_UPDATE_SURNAME,
  WARRANTY_UPDATE_SINISTER_ADDRESS,
  WARRANTY_UPDATE_EMAIL,
  WARRANTY_UPDATE_SINISTER_DATE,
  WARRANTY_UPDATE_POLICE,
  WARRANTY_UPDATE_SCORE_ASK,
  WARRANTY_UPDATE_VALIDATE_CONTRACT,
  WARRANTY_UPDATE_INMOBILIER,
  WARRANTY_UPDATE_EMBELLISSEMENT,
  WARRANTY_UPDATE_MOBILIER,
  WARRANTY_UPDATE_PISCINE,
  WARRANTY_UPDATE_EXTERIEUR,
  WARRANTY_UPDATE_CURRENT_CLAIM,
  WARRANTY_UPDATE_LITIGATION_ALERT_ABSENCE,
  WARRANTY_UPDATE_GAG_NUMBER,
  WARRANTY_UPDATE_REN_NUMBER,
  WARRANTY_UPDATE_SINISTER_CAUSE,
  WARRANTY_UPDATE_SINISTER_PLACE,
  WARRANTY_UPDATE_DAMAGE_PLACE,
  WARRANTY_UPDATE_CAUSE_REPAIRED,
  WARRANTY_UPDATE_THIRD_PARTY_INVOLVED
} from '@/store/types'
import maDatePicker from '@/components/datePicker'
import maInputBtn from '@/components/input/modules/btn'
import maInputText from '@/components/input/modules/text'
import maInputRadio from '@/components/input/modules/radio'
import maInputSelect from '@/components/input/modules/select'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maModal from '@/components/modal'
import { DATE_FORMAT } from '@/constants'

export default {
  name: 'moreInfoModal',
  data: function() {
    return {
      showModal: false,
      moreInfoSinisterCauseOptions: [
        {
            key: 'ruptureCanalisation',
            literal: 'Fuite rupture canalisation privée accessible',
            agent_icon: 'ico-pipe'
        },
        {
            key: 'baignoire',
            literal: 'Fuite/rupture appareil \u00E0 effet d\u1FFDeau',
            agent_icon: 'ico-bath-2'
        },
        {
            key: 'infiltrationToiture',
            literal: 'Infiltration toiture-terrasse',
            agent_icon: 'ico-roof'
        },
        {
            key: 'infiltrationMurs',
            literal: 'Infiltration par fa\u00E7ade',
            agent_icon: 'ico-leak'
        },
        {
            key: 'autres',
            literal: 'A déterminer',
            agent_icon: 'ico-others-2'
        }
      ],
      validContractOptions: [
        {
          key: 'oui',
          literal: 'Oui'
        },
        {
          key: 'non',
          literal: 'Non'
        }
      ],
      scoreAskOptions: [
        {
          key: 'vert',
          literal: 'Vert'
        },
        {
          key: 'orange',
          literal: 'Orange'
        },
        {
          key: 'rouge',
          literal: 'Rouge'
        }
      ],
      franchiseOptions: [
        {
          key: '0',
          literal: '0€'
        },
        {
          key: '139',
          literal: '139€'
        },
        {
          key: '159',
          literal: '159€'
        },
        {
          key: '225',
          literal: '225€'
        },
        {
          key: '280',
          literal: '280€'
        },
        {
          key: '380',
          literal: '380€'
        },
        {
          key: '800',
          literal: '800€'
        }
      ],
      franchiseInondationOptions: [
        {
          key: '280',
          literal: '280€'
        },
        {
          key: '380',
          literal: '380€'
        }
      ],
      franchiseEgoutOptions: [
        {
          key: 'franchiseEgout',
          literal: '230€'
        }
      ],
      piscineOptions: [
        {
          key: 'piscine',
          literal: 'Piscine'
        }
      ],
      externalOptions: [
        {
          key: 'exterior',
          literal: 'Aménagement Extérieur'
        }
      ],
      sinisterPlaceOptions: [
        {
          key: 'Interieur',
          literal: 'Chez moi'
        },
        {
          key: 'PasDeChezMoi',
          literal: 'Pas chez moi'
        },
        {
          key: 'SaisPas',
          literal: 'Je ne sais pas'
        }
      ],
      damagePlaceOptions: [
        {
          key: 'ChezMoi',
          literal: 'Chez moi'
        },
        {
          key: 'ChezMoiVoisin',
          literal: 'Chez moi et mon voisin'
        },
        {
          key: 'PasChezMoi',
          literal: 'Les dégâts ne sont pas chez moi'
        }
      ],
      causeRepairedOptions: [
        {
          key: 'Oui',
          literal: 'Oui'
        },
        {
          key: 'Non',
          literal: 'Non'
        },
        {
          key: 'SaisPas',
          literal: 'Je ne sais pas'
        }
      ]
    }
  },
  components: {
    maDatePicker,
    maInputBtn,
    maInputText,
    maInputSelect,
    maInputCheckbox,
    maInputRadio,
    maModal,
    maCounter
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId'
    }),
    ...mapState(WARRANTY_MODULE_ADDITIONAL_INFO, {
      stateWarrantyName: 'name',
      stateWarrantySurname: 'surname',
      stateWarrantySinisterAddress: 'sinisterAddress',
      stateWarrantyEmail: 'email',
      stateWarrantySinisterDate: 'sinisterDate',
      stateWarrantyPolice: 'numPolice',
      stateWarrantyScoreAsk: 'scoreAsk',
      stateWarrantyValidateContract: 'validateContract',
      stateWarrantyInmobilier: 'inmobiliere',
      stateWarrantyEmbellissement: 'embellissement',
      stateWarrantyMobilier: 'mobiliere',
      stateWarrantyPiscine: 'piscine',
      stateWarrantyExterieur: 'exterieur',
      stateWarrantyCurrentClaim: 'currentClaim',
      stateWarrantyLitigationAlertAbsence: 'litigationAlertAbsence',
      stateWarrantyGagNumber: 'gagNumber',
      stateWarrantyRenNumber: 'renNumber',
      stateWarrantySinisterCause: 'sinisterCause',
      stateWarrantySinisterPlace: 'sinisterPlace',
      stateWarrantyDamagePlace: 'damagePlace',
      stateWarrantyCauseRepaired: 'causeRepaired',
      stateWarrantyThirdPartyInvolved: 'thirdPartyInvolved'
    }),
    stateComWarrantyName: {
      get() {
        return this.stateWarrantyName
      },
      set(v) {
        this.mutWarrantySetName(v)
      }
    },
    stateComWarrantySurname: {
      get() {
        return this.stateWarrantySurname
      },
      set(v) {
        this.mutWarrantySetSurname(v)
      }
    },
    stateComWarrantySinisterAddress: {
      get() {
        return this.stateWarrantySinisterAddress
      },
      set(v) {
        this.mutWarrantySetSinisterAddress(v)
      }
    },
    stateComWarrantyEmail: {
      get() {
        return this.stateWarrantyEmail
      },
      set(v) {
        this.mutWarrantySetEmail(v)
      }
    },
    stateComWarrantySinisterDate: {
      get() {
        return this.stateWarrantySinisterDate
      },
      set(v) {
        this.mutWarrantySetSinisterDate(moment(v).format(DATE_FORMAT))
      }
    },
    stateComWarrantyPolice: {
      get() {
        return this.stateWarrantyPolice
      },
      set(v) {
        this.mutWarrantySetPolice(v)
      }
    },
    stateComWarrantyScoreAsk: {
      get() {
        return this.stateWarrantyScoreAsk
      },
      set(v) {
        this.mutWarrantyScoreAsk(v)
      }
    },
    stateComWarrantyValidateContract: {
      get() {
        return this.stateWarrantyValidateContract
      },
      set(v) {
        this.mutWarrantySetValidateContract(v)
      }
    },
    stateComWarrantyInmobiliere: {
      get() {
        return this.stateWarrantyInmobilier
      },
      set(v) {
        this.mutWarrantySetInmobilier(v)
      }
    },
    stateComWarrantyEmbellissement: {
      get() {
        return this.stateWarrantyEmbellissement
      },
      set(v) {
        this.mutWarrantySetEmbellissement(v)
      }
    },

    stateComWarrantyMobilier: {
      get() {
        return this.stateWarrantyMobilier
      },
      set(v) {
        this.mutWarrantySetMobilier(v)
      }
    },

    stateComWarrantyPiscine: {
      get() {
        return this.stateWarrantyPiscine
      },
      set(v) {
        this.mutWarrantySetPiscine(v)
      }
    },

    stateComWarrantyExterieur: {
      get() {
        return this.stateWarrantyExterieur
      },
      set(v) {
        this.mutWarrantySetExterieur(v)
      }
    },
    stateComWarrantyCurrentClaim: {
      get() {
        return this.stateWarrantyCurrentClaim
      },
      set(v) {
        this.mutWarrantySetClaim(v)
      }
    },
    stateComWarrantyLitigationAlertAbsence: {
      get() {
        return this.stateWarrantyLitigationAlertAbsence
      },
      set(v) {
        this.mutWarrantySetLitigationAlert(v)
      }
    },
    stateComWarrantyGagNumber: {
      get() {
        return this.stateWarrantyGagNumber
      },
      set(v) {
        this.mutWarrantySetGagNumber(v)
      }
    },
    stateComWarrantyRenNumber: {
      get() {
        return this.stateWarrantyRenNumber
      },
      set(v) {
        this.mutWarrantySetRenNumber(v)
      }
    },
    stateComWarrantySinisterCause: {
      get() {
        return this.stateWarrantySinisterCause
      },
      set(v) {
        this.mutWarrantySetSinisterCause(v)
      }
    },
    stateComWarrantySinisterPlace: {
      get() {
        return this.stateWarrantySinisterPlace
      },
      set(v) {
        this.mutWarrantySetSinisterPlace(v)
      }
    },
    stateComWarrantyDamagePlace: {
      get() {
        return this.stateWarrantyDamagePlace
      },
      set(v) {
        this.mutWarrantySetDamagePlace(v)
      }
    },
    stateComWarrantyCauseRepaired: {
      get() {
        return this.stateWarrantyCauseRepaired
      },
      set(v) {
        this.mutWarrantySetCauseRepaired(v)
      }
    },
    stateComWarrantyThirdPartyInvolved: {
      get() {
        return this.stateWarrantyThirdPartyInvolved
      },
      set(v) {
        this.mutWarrantySetThirdPartyInvolved(v)
      }
    },

    dateSelected: function() {
      return this.stateComWarrantySinisterDate
    },

    maxDate: function() {
      return new Date()
    },

    dateFormat: function() {
      return DATE_FORMAT
    },

    sinisterId: function() {
      return `- Sinistre ${this.stateWarrantySinisterId}`
    },

    isMoreInfoSendButtonEnabled: function() {
      return (
        this.stateComWarrantyName &&
        this.stateComWarrantySurname &&
        this.stateComWarrantyEmail &&
        this.stateComWarrantySinisterAddress &&
        this.stateComWarrantySinisterDate &&
        this.stateComWarrantyValidateContract &&
        this.stateComWarrantyScoreAsk &&
        this.stateComWarrantyInmobiliere &&
        this.stateComWarrantyCurrentClaim &&
        this.stateComWarrantyLitigationAlertAbsence &&
        this.stateComWarrantySinisterCause &&
        this.stateComWarrantySinisterPlace &&
        this.stateComWarrantyDamagePlace &&
        this.stateComWarrantyCauseRepaired &&
        this.stateWarrantySinisterId
      )
    }
  },
  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyUpdateProps: WARRANTY_UPDATE_PROPS
    }),
    ...mapMutations(WARRANTY_MODULE_ADDITIONAL_INFO, {
      mutWarrantySetName: WARRANTY_UPDATE_NAME,
      mutWarrantySetSurname: WARRANTY_UPDATE_SURNAME,
      mutWarrantySetSinisterAddress: WARRANTY_UPDATE_SINISTER_ADDRESS,
      mutWarrantySetEmail: WARRANTY_UPDATE_EMAIL,
      mutWarrantySetSinisterDate: WARRANTY_UPDATE_SINISTER_DATE,
      mutWarrantySetPolice: WARRANTY_UPDATE_POLICE,
      mutWarrantyScoreAsk: WARRANTY_UPDATE_SCORE_ASK,
      mutWarrantySetValidateContract: WARRANTY_UPDATE_VALIDATE_CONTRACT,
      mutWarrantySetInmobilier: WARRANTY_UPDATE_INMOBILIER,
      mutWarrantySetEmbellissement: WARRANTY_UPDATE_EMBELLISSEMENT,
      mutWarrantySetMobilier: WARRANTY_UPDATE_MOBILIER,
      mutWarrantySetPiscine: WARRANTY_UPDATE_PISCINE,
      mutWarrantySetExterieur: WARRANTY_UPDATE_EXTERIEUR,
      mutWarrantySetClaim: WARRANTY_UPDATE_CURRENT_CLAIM,
      mutWarrantySetLitigationAlert: WARRANTY_UPDATE_LITIGATION_ALERT_ABSENCE,
      mutWarrantySetGagNumber: WARRANTY_UPDATE_GAG_NUMBER,
      mutWarrantySetRenNumber: WARRANTY_UPDATE_REN_NUMBER,
      mutWarrantySetSinisterCause: WARRANTY_UPDATE_SINISTER_CAUSE,
      mutWarrantySetSinisterPlace: WARRANTY_UPDATE_SINISTER_PLACE,
      mutWarrantySetDamagePlace: WARRANTY_UPDATE_DAMAGE_PLACE,
      mutWarrantySetCauseRepaired: WARRANTY_UPDATE_CAUSE_REPAIRED,
      mutWarrantySetThirdPartyInvolved: WARRANTY_UPDATE_THIRD_PARTY_INVOLVED
    }),
    open() {
      this.$refs.linkMoreInfoModal.showModal = true
    },
    close(event) {
      this.$refs.linkMoreInfoModal.showModal = false
      this.$emit('close', event)
    },
    handleChangeSinisterDate(date) {
      this.stateComWarrantySinisterDate = date
      this.actWarrantyUpdateProps()
    },
    onFranchiseEgoutChange(event) {
      this.stateComWarrantyMobilier = event.franchiseEgout || false
    },
    onPiscineChange(event) {
      this.stateComWarrantyPiscine = event.piscine || false
    },
    onExterieurChange(event) {
      this.stateComWarrantyExterieur = event.exterior || false
    },
    transformBooleanToYesNoOption(value) {
      if (value) {
        return 'oui'
      }

      return 'non'
    },
    transformYesNoOptionToBoolean(value) {
      return value === 'oui'
    },
    sendAditionalInfo() {
      apiPostAdditionalInfo({
        IDsinistre: this.stateWarrantySinisterId,
        PrenomAssure: this.stateComWarrantyName,
        NomAssure: this.stateComWarrantySurname,
        MailAssure: this.stateComWarrantyEmail,
        AdresseAssure: this.stateComWarrantySinisterAddress,
        DATSIN: this.stateComWarrantySinisterDate,
        NumPolice: this.stateComWarrantyPolice,
        ValiditeContrat: this.stateComWarrantyValidateContract,
        ScoreFraude: this.stateComWarrantyScoreAsk,
        Franchise: parseInt(this.stateComWarrantyInmobiliere),
        Fran_Spe_NonCatnat:
          parseInt(this.stateComWarrantyEmbellissement) || undefined,
        Fran_Spe_Eau: this.transformBooleanToYesNoOption(
          this.stateComWarrantyMobilier
        ),
        OptionPiscine: this.transformBooleanToYesNoOption(
          this.stateComWarrantyPiscine
        ),
        OptionAmExt: this.transformBooleanToYesNoOption(
          this.stateComWarrantyExterieur
        ),
        AbsenceSinistre: this.stateComWarrantyCurrentClaim,
        Flag_CTX: this.transformYesNoOptionToBoolean(
          this.stateComWarrantyLitigationAlertAbsence
        ),
        NombreGAG: this.stateComWarrantyGagNumber,
        NombreREN: this.stateComWarrantyRenNumber,
        GDC: this.stateComWarrantySinisterCause,
        Origine: this.stateComWarrantySinisterPlace,
        LocDegats: this.stateComWarrantyDamagePlace,
        CauseRep: this.stateComWarrantyCauseRepaired,
        TiersIdentifie: this.stateComWarrantyThirdPartyInvolved || undefined
      })
        .then(() => {
          this.close(true)
          this.throwNotification(
            this.$t('warrantyProps.moreInfoModal.sendOk'),
            '',
            'OK'
          )
        })
        .catch(() =>
          this.throwNotification(
            this.$t('warrantyProps.moreInfoModal.sendError'),
            '',
            'KO'
          )
        )
    }
  }
}
